import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { AuthProvider } from './auth'
import { ThemeModeProvider } from './components/ThemeModeContext'
import App from './App.tsx'
import './index.css'
import { initAnalytics } from './services/analytics'

// Initialize i18n
import './i18n'

// Initialize analytics (gated behind the analytics feature flag)
initAnalytics()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthProvider>
      <ThemeModeProvider>
        <App />
      </ThemeModeProvider>
    </AuthProvider>
  </StrictMode>,
)
